const env = process.env;
export default {
  isDebug: env.NODE_ENV !== 'production',
  appMode: env.APP_MODE,
  isOpen: env.APP_MODE === 'open'
};



// WEBPACK FOOTER //
// ./src/common/ProcessEnv.js